import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { Input } from '@salesforce/design-system-react';

import './FtpInfo.scss';

class FtpInfo extends Component {
  getI18nID(suffix) {
    return `components.ecs.advancedSettings.dataExtensionSync.${suffix}`;
  }

  isFTP() {
    return this.props?.flags?.ftpImport || this.props?.flags?.flags?.ftpImport;
  }

  handleFtpInfoChange(ftpFilename) {
    this.props.handleFtpInfoChange(ftpFilename.target.value);
  }

  renderFtpInfo() {
    const { formatMessage } = this.props.intl;
    return (
      <div className="ftp-info-container">
        <div className="label">
          <h2>
            <FormattedMessage
              id={this.getI18nID('selectionModal.labels.ftp')}
            />
          </h2>
        </div>
        <div className="ftp-info-selector">
          <Input
            label={formatMessage({
              id: this.getI18nID('selectionModal.labels.ftpFilename')
            })}
            id="ftp-file-name"
            value={this.props.ftpFilename.file_name}
            onChange={this.handleFtpInfoChange.bind(this)}
            required
          />
        </div>
      </div>
    );
  }

  render() {
    return <div>{this.isFTP() ? this.renderFtpInfo() : null}</div>;
  }
}

FtpInfo.propTypes = {
  ftpFilename: PropTypes.object,
  handleFtpInfoChange: PropTypes.func,
  flags: PropTypes.object.isRequired
};

export default injectIntl(FtpInfo);
